import React from 'react';
import './App.css';
import Navbar from './components/Navbar.js'

function App() {
  return (
    <div>
      <Navbar />
    </div>
  );
}

export default App;
